import { UseFormSetValue } from "react-hook-form";
import * as Yup from "yup";
import {useGetDropCatRic, useGetDropLivelliRic, useGetDropStatiRic, validationSchemaRic} from "./Services";
import {FieldDescriptor} from "../../common/FormField";
import {useGetDropCatNC, useGetDropLivelliNC, useGetDropStatiNC} from "../gestnc/Services";
import {NCForm} from "../gestnc/FormNC";

type RicForm = Yup.InferType<typeof validationSchemaRic>;

type FieldConfig = {
  name: keyof RicForm;
  label: string;
  type?: string;
  options?: Array<{ value: string | number; label: string }>;
  xs?: number;
  multiline?: boolean;
  rows?: number;
};

export const useFieldsRic_1 = (): FieldConfig[] => [
  { name: "ditta", label: "Ditta", type: "number", xs: 2 },
  { name: "coddip", label: "Dipendente", xs: 3 },
  { name: "idprog", label: "Progetto", xs: 3 },
  { name: "dataric", label: "Data richiesta", type: "date", xs: 4 },
];

export const useFieldsRic_2 = (): FieldConfig[] => [
  { name: "titolo", label: "Titolo", xs: 4 },
  { name: "canale", label: "Canale", xs: 2 },
  { name: "codcli", label: "Codice cliente", type: "number", xs: 2 },
  { name: "refcliente", label: "Referente cliente", xs: 4 },
];



export const useFieldsRic_3 = (): FieldDescriptor<RicForm>[] => {
  const {data: DropCatRicApiResponse} = useGetDropCatRic();
  const {data: DropStatiRicApiResponse} = useGetDropStatiRic();
  const {data: DropLivelliRicApiResponse} = useGetDropLivelliRic();

  return [
      {
      name: "idcatric", label: "Categoria", type: "autocomplete", boxSize: "33%",
      options: () => DropCatRicApiResponse?.results ?? [], optionLabelKey: "descatric", optionValueKey: "idcatirc",
    },
    {
      name: "idstatoric", label: "Stato", type: "autocomplete", boxSize: "33%",
      options: () => DropStatiRicApiResponse?.results ?? [], optionLabelKey: "desstatoric", optionValueKey: "idstatoric",
    },
    {
      name: "idlivelloric", label: "Livello", type: "autocomplete", boxSize: "33%",
      options: () => DropLivelliRicApiResponse?.results ?? [], optionLabelKey: "deslivelloric", optionValueKey: "idlivelloric",
    },
  ];
};

export const useFieldsRic_4 = (): FieldConfig[] => [
  { name: "note", label: "Note", multiline: true, rows: 4, xs: 12 },
  { name: "dataapertura", label: "Data apertura", type: "date", xs: 3 },
  { name: "datachiusura", label: "Data chiusura", type: "date", xs: 3 },
  { name: "datavalutazione", label: "Data valutazione", type: "date", xs: 3 },
  { name: "valutatore", label: "Valutatore", xs: 3 },
];
